import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { activateUserAccount } from "services/apis/admin";

export const activateUser = createAsyncThunk(
  "user/activate",
  async ({ userId, token }: { userId: any; token: string }, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append("user_id", userId);
      const { data } = await activateUserAccount(token, formData);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

interface ActivateUserState {
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: ActivateUserState = {
  status: "idle",
  error: null,
};

const activateUserSlice = createSlice({
  name: "activateUser",
  initialState,
  reducers: {
    resetActivateUserStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(activateUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(activateUser.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(activateUser.rejected, (state, action: any) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export const { resetActivateUserStatus } = activateUserSlice.actions;
export default activateUserSlice.reducer;
